declare namespace $ {

	export class $mol_icon_newspaper extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=newspaper.view.tree.d.ts.map